import { useQuery } from 'react-query';

import { useApi } from '@/lib/api';
import { useLocale } from '@/lib/contexts';

type GetArProps = {
  workspaceId: string;
  activityReportId: string | undefined;
};

export function useGetActivityReport({
  workspaceId,
  activityReportId,
}: GetArProps) {
  const { api } = useApi();
  const { locale } = useLocale();

  return useQuery(
    ['ar-get', workspaceId, activityReportId, locale],
    async () =>
      typeof workspaceId === 'string' && typeof activityReportId === 'string'
        ? api.geodata.activityReports.getActivityReport(
            workspaceId,
            activityReportId
          )
        : undefined,
    {
      enabled: !!workspaceId && !!activityReportId,
    }
  );
}
